import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Services
import { ElasticService } from './../../../services/elastic';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import { ApiService } from './../../../services/api';

import { OAuthService } from './../../../services/o-auth';
import { FormsService } from './../../../services/forms';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import * as lodash from 'lodash';
@Component({
  templateUrl: 'insight.component.html',
  selector:"app-company-insights"
})
export class CompanyInsightComponent implements OnInit {

  public club: any;
  public follow: any;
  public form: FormGroup;

  public notification: Array<{ id: string; count: number; name: string; checkImage: string; unCheckImage: string; isActive: boolean }>;
  public offerCount: number;
  public insightFollower: Array<any>;
  public notifyType = ''
  constructor(private apiService: ApiService, private route: Router, private elasticService: ElasticService, private fireDatabase: AngularFireDatabase, private oAuthService: OAuthService, public formsService: FormsService) {
    this.club = this.oAuthService.getClub();
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      body: new FormControl('', Validators.required),
      author: new FormControl(this.club.cid)
    });
  }
  ngOnInit(): void {
    this.createNotification();
    this.getClubInsight();

    this.apiService.object(`/user-followers/${this.club.cid}`)
      .then(result => {

        if (result && result.count > 0) {
          this.follow = [];
          this.follow = result;
          lodash.forEach(result.followers, (item, key) => {
            if (item) {
              //   console.log("item   " + item + "  key  " + key)
              this.apiService.object(`/user-push-settings/${key}`)
                .then(result => {
                  //     console.log(result)
                  this.increaseNotification();
                  lodash.forEach(result, (item1, key1) => {
                    if (key1 == this.club.cid) {
                      //      console.log(item1)
                      if (item1) {
                        lodash.forEach(item1, (item2, key2) => {
                          for (var i = 0; i < this.notification.length; i++) {
                            if (key2 == this.notification[i].id && item2) {
                              this.notification[i].count--;
                            }
                          }
                        })
                      }
                    }
                  })
                })
            }
          })
        }
      }
      )
  }
  public followerClick(follow) {
    $('#myModal').modal('hide');
    this.route.navigate(['/home/components/followerDetail', follow.cid]);
  }
  private getClubInsight() {
    this.apiService.object(`/users/${this.club.cid}/insights`)
      .then(result => {
        //  console.log(result)
        //     console.log(result)
        lodash.forEach(result, (item, key) => {

          for (var i = 0; i < this.notification.length; i++) {
            if (key == this.notification[i].id && item) {

              this.notification[i].isActive = false;
              //    console.log(key + "  " + this.notification[i].id + "  " + item)
              // console.log(this.notification)

            }
          }

        })

      })
  }


  public getFollower(id) {
    // console.log(this.follow)
    this.insightFollower = [];

    // var followUid = [];
    lodash.forEach(this.follow.followers, (item, key) => {
      if (item) {

        //  console.log("item   " + item + "  key  " + key)
        this.apiService.object(`/user-push-settings/${key}/${this.club.cid}/${id}`)
          .then(result => {

            if (result && !result.$value) {

              this.apiService.object(`/users/${key}`)
                .then((user: any) => {

                  console.log(user)
                  this.insightFollower.push(user)
                });
            }
            $('#myModal').modal('show');

          })
      }
    })

  }
  public insightClick(not) {
    if (not.isActive) {
      if (confirm('Are you sure, you want to disable the notification?')) {

        this.apiService.set(`/users/${this.club.cid}/insights/${not.id}`, 2)
          .then(() => {
            // this.getClubInsight();
            // this.ngOnInit();
            not.isActive = false

          })
          .catch(error => {
            console.error(error);

          });
      }
    } else {
      if (confirm('Are you sure, you want to enable the notification?')) {

        this.apiService.set(`/users/${this.club.cid}/insights/${not.id}`, 1)
          .then(() => {
            // this.getClubInsight();
            not.isActive = true

            // this.ngOnInit();
          })
          .catch(error => {
            console.error(error);

          });
      }
    }

  }
  createNotification() {


    this.club = this.oAuthService.getClub();
    this.notification = []
    if (this.club.insights) {
      lodash.forEach(this.club.insights, (item, key) => {
        if (item && key) {
          this.apiService.object("master/company-insights/" + key).then((element) => {
            if (element.status == 1) {
              this.notification.push({ id: element.cid, name: element.name, count: 0, checkImage: element.selectedimg, unCheckImage: element.unselectedimg, isActive: item == 1 })

            }
          })

        }

      })

    }
  }
  increaseNotification() {
    lodash.forEach(this.notification, (item, key) => {

      item.count++;
    })
    // console.log(this.notification)

  }
  openPopup(id) {
    $('#PostModal').modal('show');
    this.notifyType = id
  }
  public submit() {

    var followUid = [];
    lodash.forEach(this.follow.followers, (item, key) => {
      if (item) {
        followUid.push(key)
        this.apiService.object(`/user-push-settings/${key}`)
          .then(result => {
            if (result) {
              lodash.forEach(result, (item1, key1) => {
                if (key1 == this.club.cid) {
                  if (item1) {
                    lodash.forEach(item1, (item2, key2) => {
                      if (this.notifyType == key2 && item2) {
                        var i = followUid.indexOf(key);
                        if (i != -1) {
                          followUid.splice(i, 1)
                        }
                      }
                    })
                  }
                }
              })
            }
          })
      }
    })

    var form = this.form.value
    form.type = this.notifyType
    form.users = followUid
    console.log(form)
    this.fireDatabase.database.ref(`/server-process/club-notification/${this.club.cid}`)
      .set(form)
      .then(() => {
        alert('Notification is Sent!')
        $('#PostModal').modal('hide');

      })
      .catch(error => {
        console.error(error);
      });
  }
}



